import React from 'react';
import "./Services.css"
const Services = () => {
    return (
        <div className="socalmediame">
            <div>
                <h1>Hi there,</h1>
                <h2>Developer is Sleeping now !!</h2>
                <h3>ALL services details will be available soon.</h3>
            </div>

        </div>
    );
};

export default Services;